import { CheckoutState } from '@raskrask-dk/bookingflow-state-machine'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { BasisTypeBF } from '../../../models'
import { PropsInformationTemplate } from './props'
import BookingInformationTemplate from './template'
import { useBFSM } from '../../../contexts/bfsmContext'
import { getBasisTypeNameFromId } from '../../../utils/getBasisTypeNameFromId'
import { BasisType, Booking } from '@raskrask-dk/raskrask-utils'

const BookingInformationPage = (): ReactElement => {
    const { t } = useTranslation()
    const [BFSM] = useBFSM()

    const data = BFSM.getData<CheckoutState>()
    const booking = data.product as Booking
    const basisType = new BasisType(
        getBasisTypeNameFromId(data.product.service.goal.basisTypeId),
        data.product.service.goal.basisTypeId
    )
    const { email, name, phone } = data.customer

    const { serviceDate: date, service, partner } = booking
    const goal = service.goal
    const serviceType = service
    const time = date.toString('HH:mm')

    const bookInformations: PropsInformationTemplate[] = [
        { preText: t('common:date'), postText: date!.toString('dd/MM/yyyy') },
        { preText: t('common:time'), postText: time! },
        {
            preText: t(`common:basistypes.${basisType!.id}.singularis`),
            postText: partner!.alias,
        },
    ]

    const customerInformation: PropsInformationTemplate[] = [
        { preText: t('common:name'), postText: name },
        { preText: t('common:email'), postText: email },
        { preText: t('common:phone'), postText: phone.toString() },
    ]

    return (
        <BookingInformationTemplate
            goalName={t(`common:goals.${goal!.id}`)}
            icon={(basisType as BasisTypeBF).icon}
            bookingInformations={bookInformations}
            customerInformations={customerInformation}
            serviceLength={`${
                serviceType!.duration.toMillis() / 60 / 1000
            } min`}
        />
    )
}

export default BookingInformationPage
